import React from 'react';
import { ArrowLeft, Crown, Coins } from 'lucide-react';
import type { User } from '../../types/user';

interface GameHeaderProps {
  onBack: () => void;
  user: User | null;
}

export function GameHeader({ onBack, user }: GameHeaderProps) {
  return (
    <div className="flex justify-between items-center mb-8">
      <div className="flex items-center gap-4">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-yellow-500 hover:text-yellow-400"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Kingdom
        </button>
        <h1 className="text-2xl font-bold font-serif bg-gradient-to-r from-yellow-500 to-amber-500 text-transparent bg-clip-text">
          Royal Games
        </h1>
      </div>
      
      <div className="flex items-center gap-4 bg-gray-900/50 px-4 py-2 rounded-lg border border-amber-600/20">
        <Crown className="w-5 h-5 text-yellow-500" />
        <span className="text-yellow-500 font-serif">{user?.username}</span>
        <div className="flex items-center gap-1">
          <Coins className="w-4 h-4 text-amber-200" />
          <span className="text-amber-200 font-mono">{user?.points} coins</span>
        </div>
      </div>
    </div>
  );
}